export default {
  getWeblinkUrl(weblink) {
    let url = weblink ? weblink.url : null;
    if (!url) return;
    if (weblink.intern === 1 && weblink.url.includes('https://youtu.be/')) {
      url = url.replace('https://youtu.be/', 'https://www.youtube.com/embed/');
      //https://youtu.be/uKHoxagUx7k
      //https://www.youtube.com/embed/uKHoxagUx7k
    } else if (weblink.intern === 1 && weblink.url.includes('youtube.com')) {
      // In case of a simply copied url it includes feature=share and needs to be replaced
      if (url.includes('feature=share')) {
        url = url.replace('?feature=share', '');
        url = url.replace('www.youtube.com/live/', 'www.youtube.com/embed/');
      }
    }
    let startsWithWww = url.indexOf('www') < 2 && url.indexOf('www') > -1;
    return startsWithWww ? `https://${url}` : url;
  },
};
